import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minimumPercentageRangeValidator(
  minPercentageControlName: string,
  maxPercentageControlName: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const minControl = control.parent.get(minPercentageControlName);
    const maxControl = control.parent.get(maxPercentageControlName);

    if (!minControl || !maxControl) return null;

    const min = Number(minControl.value);
    const max = Number(maxControl.value);

    if (isNaN(min) || isNaN(max)) return null;

    if (control === minControl && min >= max) {
      return { invalidMinimumPercentage: true };
    }

    return null;
  };
}
